var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWallyNotitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "148px",
    height: "64px",
    viewBox: "0 0 148 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, -0.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8431326,15.9427731 L82.6984424,16.0553099 C82.7468054,16.1125521 82.8165511,16.1474249 82.8913626,16.15177 L82.8431326,15.9427731 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "94.8524126 23.508364 100.503731 18.4587736 102.890753 21.4475232 97.2394344 26.4971136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "90.8332426 18.9848331 96.4839666 14.4396035 98.8715826 17.12888 93.2208586 21.6741096"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "87.6179065 14.1612309 92.7040929 9.6165995 94.8524126 12.3064741 89.7662262 16.8511055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2075729,14.4396035 L78.7757325,12.3129251 L79.6695305,9.85133665 C79.8229148,9.42787213 80.0165007,9.01869499 80.2478703,8.62891518 L85.8209637,11.8273056 L84.2436731,5.79892576 C84.8159743,5.65813588 85.4053039,5.59056362 85.9962182,5.59797977 C87.8363709,5.60377003 89.5901639,6.34449675 90.8332426,7.64093071 L85.7859128,11.8775421 L86.0137436,11.9947606 L85.2075729,14.4396035 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2909353,59.4543078 C20.0627086,59.4500527 18.0034916,58.0769904 16.8805141,55.8467008 L22.3075827,52.2198018 L22.5073521,59.4543078 L22.2909353,59.4543078 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3420341,57.0428058 L22.7175557,51.9169078 L22.8752084,51.8198264 C22.8257188,51.7310633 22.7412779,51.6734655 22.6474879,51.6644961 L22.6474879,51.8392427 L22.5073521,51.6839124 L24.9246931,49.0044657 L29.7418582,54.3633591 L27.3420341,57.0428058 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "14.4690121 49.8188061 21.2299747 47.3967977 22.5073521 50.6016274 15.7463895 53.0236358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "26.5265222 48.4679529 29.2065924 45.7891297 34.5648622 51.1486466 31.884792 53.8274698"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "30.5456922 43.3770666 33.2257624 40.9661257 38.5840322 45.7896909 35.903962 48.2006317"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "12.8613441 44.1912398 19.6228738 41.7699597 20.8996841 44.9755176 14.1381544 47.3967977"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "35.3686962 40.1622917 37.7801982 37.7507897 42.6032023 42.5737937 40.1917003 44.9852957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "10.4498421 39.3682358 16.5352188 36.9469557 17.6843481 40.1525136 11.5989714 42.5737937"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "8.84217406 32.9375638 14.9275508 30.5162836 16.0766801 33.7218415 9.99130335 36.1431217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "6.43067204 28.1145597 12.5160488 25.6932796 13.6651781 28.8988375 7.57980133 31.3201176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "4.01917003 22.4877217 10.7806997 20.0664416 12.0575101 23.2719995 5.29598035 25.6932796"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "1.60766801 16.5149865 8.36919773 14.4396035 9.64600806 17.1872246 2.88447834 19.2626076"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "-5.57771888e-17 11.2340456 6.76152972 8.81276549 8.03834005 12.0183234 1.27681033 14.4396035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5039368,40.9661257 L39.3878662,35.8424988 L39.3878662,35.8424988 C40.4680645,34.4871798 41.9393863,33.7269425 43.4731048,33.7316196 C43.9942048,33.7367808 44.5125049,33.827105 45.0147043,34.0002959 L43.5039368,40.9661257 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6032023,33.9981748 C43.1054017,33.8263512 43.6237017,33.7367401 44.1448017,33.7316196 C45.6785203,33.7269794 47.149842,34.4812148 48.2300403,35.825834 L48.2300403,35.825834 L44.1448017,40.9661257 L42.6032023,33.9981748 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5231372,59.4350671 L64.3067204,59.4350671 L64.5231372,52.2198018 L69.9335584,55.8562955 C68.8130618,58.083536 66.7522735,59.4539916 64.5231372,59.4543078 L64.5231372,59.4350671 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0722144,55.4940987 L62.4311077,50.6121338 L65.1105544,53.0531162 L64.9552242,53.1946225 L64.9552242,53.035428 C64.861747,53.044588 64.7769933,53.0896276 64.7222288,53.1592459 L64.877559,53.1592459 L59.751661,57.8466398 L57.0722144,55.4940987 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "65.1105544 50.6016274 66.3879318 47.3967977 73.1488945 49.8188061 71.871517 53.0236358"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "53.0530443 51.1486466 57.8754871 45.7891297 60.2875504 48.4679529 55.4651076 53.8274698"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "49.0338743 47.1294766 53.8563171 41.7699597 56.2683804 44.4487829 51.4459375 49.8082997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "66.7182224 45.3214148 67.9950327 42.5737937 74.7565625 44.6491767 73.4797521 47.3967977"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "45.0147043 42.5737937 49.8377083 37.7507897 52.2492103 40.1622917 47.4262063 44.9852957"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "69.1297244 40.1525136 70.4065348 36.9469557 77.1680645 39.3682358 75.8912542 42.5737937"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "70.7373924 33.7218415 72.0142028 30.5162836 78.7757325 32.9375638 77.4989222 36.1431217"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "73.1488945 28.8988375 74.4257048 25.6932796 81.1872345 28.1145597 79.9104242 31.3201176"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "74.7565625 23.2719995 76.0333728 20.0664416 82.7949025 22.4877217 81.5180922 25.6932796"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "77.9718985 17.1872246 79.1210278 14.4396035 85.2064045 16.5149865 84.0572752 19.2626076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1584993,40.1917003 C43.3592926,40.1863442 42.5959713,39.8655225 42.0408394,39.3016539 C39.6384521,36.8583895 27.6799022,24.2406738 27.6799022,16.1604492 C27.6799022,7.23527954 35.0576214,0 44.1584993,0 C53.2593772,0 60.6370964,7.23527954 60.6370964,16.1604492 C60.6370964,24.2406738 48.660751,36.8583895 46.2761592,39.3016539 C45.7210273,39.8655225 44.9577059,40.1863442 44.1584993,40.1917003 Z M44.158492,5.89919503 C38.3670283,5.89919503 33.6721193,10.5955838 33.6721193,16.3888729 C33.6721193,20.0952257 39.2298968,27.8226218 44.158492,33.3297026 C48.8424051,28.0848637 54.6448792,20.2700537 54.6448792,16.3888729 C54.649505,13.6038095 53.5467427,10.9312253 51.5796632,8.96024627 C49.6125837,6.98926724 46.9426817,5.88171223 44.158492,5.88171223 L44.158492,5.89919503 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44605,63.5028864 C95.3561719,63.4932866 87.9870587,56.2711159 87.9674525,47.3528779 C87.9674525,39.2691439 99.9260025,26.6284886 102.32839,24.184163 C102.88534,23.6248034 103.649034,23.3099819 104.44605,23.3111861 L104.44605,23.3111861 C105.243065,23.3099819 106.006759,23.6248034 106.56371,24.184163 C108.966097,26.6459481 120.924647,39.2691439 120.924647,47.3528779 C120.905041,56.2711159 113.535927,63.4932866 104.44605,63.5028864 L104.44605,63.5028864 Z M104.515957,30.1731837 C99.832138,35.3792986 94.0297946,43.119056 94.0297946,46.9889347 C93.564485,50.9701878 95.4418536,54.8632129 98.8572091,56.9993538 C102.272565,59.1354948 106.619535,59.1354948 110.03489,56.9993538 C113.450246,54.8632129 115.327614,50.9701878 114.862305,46.9889347 C114.932212,43.119056 109.199777,35.414006 104.515957,30.1731837 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.526817,22.4779436 L108.517591,27.7016588 L108.517591,27.7016588 C107.420531,29.0286553 105.945203,29.7519965 104.419785,29.71078 C103.901592,29.6929835 103.387514,29.5900518 102.890753,29.4046282 L104.526817,22.4779436 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.302255,29.479209 C104.798825,29.6498213 104.277998,29.7275867 103.75642,29.7100199 C102.213713,29.6778594 100.744961,28.8817835 99.6754166,27.4980817 L99.6754166,27.4980817 L103.833712,22.4779436 L105.302255,29.479209 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.614522,4.79359547 C127.843658,4.79391171 129.904446,6.16436727 131.024943,8.39160778 L125.614522,12.0281015 L125.398105,4.79359547 L125.614522,4.79359547 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.843045,6.40126348 L125.968943,10.9923923 L125.813613,10.9923923 C125.852805,11.0766397 125.94471,11.1315174 126.046609,11.1315174 L126.046609,10.9750017 L126.201939,11.1141268 L123.522492,13.6357695 L118.163599,8.83595301 L120.843045,6.40126348 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "126.201939 13.6462759 132.962901 11.2242675 134.240279 14.4290971 127.479316 16.8511055"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "114.144429 13.0992567 116.824499 10.4204335 122.182769 15.7799504 119.502699 18.4587736"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "110.125259 17.1184267 112.537322 14.4396035 117.359765 19.7991204 114.947702 22.4779436"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "127.809607 18.9264885 134.571137 16.8511055 135.847947 19.5987266 129.086417 21.6741096"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "106.106089 21.6741096 108.517591 19.2626076 113.340595 24.0856116 110.929093 26.4971136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "130.221109 24.0953897 136.982639 21.6741096 138.259449 24.8796675 131.497919 27.3009476"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "131.828777 30.5260618 138.590307 28.1047816 139.867117 31.3103395 133.105587 33.7316196"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "134.240279 35.3490658 141.001809 32.9277856 142.278619 36.1333435 135.517089 38.5546237"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "136.651781 40.9759038 142.737158 38.5546237 143.886287 41.7601816 137.80091 44.1814617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "139.063283 46.2568447 145.14866 44.1814617 146.297789 46.9290828 140.212412 49.0044657"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    points: "140.670951 52.2295799 146.756328 49.8082997 147.905457 53.0138576 141.82008 55.4351378"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWallyNotitle);
export default __webpack_public_path__ + "static/media/logo_wally-notitle.d7f04f8853186fa4ff46f2aa3c4ed0b5.svg";
export { ForwardRef as ReactComponent };